var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgPatternHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 136,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h375v136H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#5964E0",
    transform: "matrix(-1 0 0 1 375 0)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    fill: "#FFF",
    opacity: 0.081
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.06-362.235l344.16 164.899c20.42 9.784 29.043 34.27 19.259 54.69a41 41 0 01-13.459 15.87L356.104 88.129c-18.548 12.988-44.114 8.48-57.102-10.069a41 41 0 01-7.219-19.515L254.54-321.26c-2.21-22.535 14.268-42.595 36.803-44.805a41 41 0 0121.717 3.83zM-12.94 32.765l344.16 164.899c20.42 9.784 29.043 34.27 19.259 54.69a41 41 0 01-13.459 15.87L30.104 483.129c-18.548 12.988-44.114 8.48-57.102-10.069a41 41 0 01-7.219-19.515L-71.46 73.74c-2.21-22.535 14.268-42.595 36.803-44.805a41 41 0 0121.717 3.83z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternHeader);
export default __webpack_public_path__ + "static/media/bg-pattern-header.ea1134f14277d29c5f40360a34f4af0a.svg";
export { ForwardRef as ReactComponent };